import { createContext, useContext } from "react";

interface ComingSoonContextValue {
  openComingSoonModal: () => void;
}

export const ComingSoonContext = createContext<ComingSoonContextValue>({
  openComingSoonModal: () => {},
});

export const useComingSoon = () => useContext(ComingSoonContext);
